var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userLoaded && _vm.user.can('view_rootentity'))?_c('v-container',[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" Queue Status ")]),_c('v-card-text',[_c('pre',[_vm._v(_vm._s(_vm.data))])])],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }